export default function makeOnNodeDragEnd(node) {
  // we want to reassign the params to keep new position for the node
  // eslint-disable-next-line no-param-reassign
  node.fx = node.x;
  // eslint-disable-next-line no-param-reassign
  node.fy = node.y;
  // eslint-disable-next-line no-param-reassign
  node.fz = node.z;
}
